/**
 * Determines if two line segments (p1-p2 and q1-q2) intersect.
 * Uses the counter-clockwise (ccw) method to check for intersection.
 *
 * @param p1 - The first endpoint of the first line segment.
 * @param p2 - The second endpoint of the first line segment.
 * @param q1 - The first endpoint of the second line segment.
 * @param q2 - The second endpoint of the second line segment.
 * @returns True if the line segments intersect, false otherwise.
 */
export function doLinesIntersect(
  p1: { x: number; y: number },
  p2: { x: number; y: number },
  q1: { x: number; y: number },
  q2: { x: number; y: number },
) {
  function ccw(a: { x: number; y: number }, b: { x: number; y: number }, c: { x: number; y: number }) {
    return (c.y - a.y) * (b.x - a.x) > (b.y - a.y) * (c.x - a.x);
  }

  return ccw(p1, q1, q2) !== ccw(p2, q1, q2) && ccw(p1, p2, q1) !== ccw(p1, p2, q2);
}
